/** :root に定義されたトークンの値を読む。Monaco や xterm など CSS を解釈しない相手へ渡すために使う。 */
export function tokenReader() {
	const style = getComputedStyle(document.documentElement);
	return (name: string) => {
		const value = style.getPropertyValue(name).trim();
		if (!value) throw new Error(`CSS カスタムプロパティ ${name} が定義されていません。`);
		return value;
	};
}
